import { faRectangleHistoryCirclePlus } from "@fortawesome/pro-regular-svg-icons/faRectangleHistoryCirclePlus";
import * as React from "react";

import { useMprcTheme } from "components/MprcThemeProvider";
import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconPublicationThread: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    const { theme } = useMprcTheme();
    return <MprcIconFa {...props} icon={faRectangleHistoryCirclePlus} title={theme.iconButtons.IconPublicationThread.title} />;
};
